module.exports = __webpack_public_path__ + "img/logo.42922809.svg";